require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./post-xbox-one-elite-controller-review.json") })
        }
      }, "path---post-xbox-one-elite-controller-review");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---post-xbox-one-elite-controller-review!./.cache/json/post-xbox-one-elite-controller-review.json
// module id = 371
// module chunks = 231608221292675